<template>
  <div class="surveillance-container">
    <iframe :src="url" scrolling="auto" seamless height="100%" width="100%" frameborder="0" allowfullscreen ref="iframe" class="iframe-container"></iframe>
  </div>
</template>

<script>
export default {
  name: 'surveillance',
  data () {
    return {
      url: 'http://fes.natsuki.cc:8022/viewer/gzQmsRNjFnCk3R7g'
    }
  },
  watch: {
    themeDark: function () {
      console.log('换主题1')
      this.pageReload()
    }
  },
  computed: {
    themeDark () {
      return this.$store.state.app.theme === '252C47'
    }
  },
  methods: {
    pageReload () {
      this.reload()
    }
  },
  created () {
  },
  mounted () {
    window.addEventListener('message', (e) => {
      console.log('传入')
      const params = {
        theme: this.$store.state.app.theme
      }
      this.$refs.iframe.contentWindow.postMessage(JSON.stringify(params), '*')
    })
  }
}
</script>

<style lang="scss" scoped>
.surveillance-container {
  width: 100%;
  height: 100%;
  margin: 0 0;
  padding: 0 0;
}
</style>
